import React, { useState } from 'react';
import {Button, Header, Segment} from "semantic-ui-react";
import axios from 'axios';
import ValidationError from './ValidationError';

export default function TestErrors() {
    ////const baseUrl = 'http://localhost:5000/api';
    const baseUrl = process.env.REACT_APP_API_URL; //'n >> no need, becouse we using axios.defaults.baseURL in agent.ts
    console.log('TestError : ' + baseUrl);

    const [errors, setErrors] = useState(null); //' n

    function handleNotFound() {
        //axios.get(baseUrl + '/buggy/not-found').catch(err => console.log(err.response));
        axios.get('/buggy/not-found').catch(err => console.log(err.response)); //'n
    }

    function handleBadRequest() {
        //axios.get(baseUrl + '/buggy/bad-request').catch(err => console.log(err.response));
        axios.get('/buggy/bad-request').catch(err => console.log(err.response)); //'n
    }

    function handleServerError() {
        //axios.get(baseUrl + '/buggy/server-error').catch(err => console.log(err.response));
        //axios.get(baseUrl + '/buggy/server-error').catch(err => console.log(err.response));
        axios.get('/buggy/server-error').catch(err => console.log(err.response)); //'n
    }

    function handleUnauthorised() {
        //axios.get(baseUrl + '/buggy/unauthorised').catch(err => console.log(err.response));
        axios.get('/buggy/unauthorised').catch(err => console.log(err.response)); //'n
    }

    function handleBadGuid() {
        //axios.get(baseUrl + '/activities/notaguid').catch(err => console.log(err));
        axios.get('/activities/notaguid').catch(err => console.log(err)); //'n
    }

    function handleValidationError() {
        //axios.post(baseUrl + '/activities', {}).catch(err => console.log(err.response)); //' x
        //axios.post(baseUrl + '/activities', {}).catch(err => console.log(err)); //' n
        // axios.post(baseUrl + '/activities', {}).catch(err => {  //' n
        //     console.log(err);  
        //     setErrors(err); 
        // });
        axios.post('/activities', {}).catch(err => {  //' n
            console.log(err);  
            setErrors(err); 
        });
    }

    return (
        <>
            <Header as='h1' content='Test Error component' />
            <Segment>
                <Button.Group widths='7'>
                    <Button onClick={handleNotFound} content='Not Found' basic primary />
                    <Button onClick={handleBadRequest} content='Bad Request' basic primary />
                    <Button onClick={handleValidationError} content='Validation Error' basic primary />
                    <Button onClick={handleServerError} content='Server Error' basic primary />
                    <Button onClick={handleUnauthorised} content='Unauthorised' basic primary />
                    <Button onClick={handleBadGuid} content='Bad Guid' basic primary />
                </Button.Group>
            </Segment>
            {errors && <ValidationError errors={errors} />}
        </>
    )
}
